<div class="my-tables-page-container">
  <mat-tab-group [(selectedIndex)]="selectedTabIndex">
    <mat-tab label="View Tables">
      <ng-template matTabContent>
        <bhub-view-tables></bhub-view-tables>
      </ng-template>
    </mat-tab>

    <mat-tab label="Manage Tables">
      <ng-template matTabContent>
        <bhub-manage-tables></bhub-manage-tables>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
